import React, { useState } from 'react';
import classNames from 'classnames';
import useNetworks from '../../hooks/useNetworks';
import Network from './Network';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { ChevronUpIcon } from '@heroicons/react/20/solid';

const MAX_NETWORKS = 1;

export default function Networks(props) {
  const networks = useNetworks();

  const [showAll, setShowAll] = useState(false);

  const visibleNetworks = showAll ? networks.data : networks.data.slice(0, MAX_NETWORKS);

  return (
    <>
      {visibleNetworks.map(function(network) {
        return (
          <Network
            key={network.id}
            network={network}
          />
        );
      })}
      {networks.data.length > MAX_NETWORKS && (
        <div className="flex justify-center">
          <div className={classNames(
            'border border-cs-gray-300',
            'rounded-full p-1',
            'hover:cursor-pointer hover:bg-gray-100'
          )} onClick={() => setShowAll(!showAll)}>
            {showAll ? (
              <ChevronUpIcon className="h-4 w-4 text-cs-gray-400" aria-hidden="true" />
            ) : (
              <ChevronDownIcon className="h-4 w-4 text-cs-gray-400" aria-hidden="true" />
            )}
          </div>
        </div>
      )}
    </>
  );
};
